import { BearerType } from 'Quotes/QuoteBuilder/components/Configure/Bearer/BearerType';
import { Supplier } from 'Quotes/types/supplier';
import { isCityFibreFlex } from './supplierHelpers';

export function presentProductNameForDisplay(productName: string | null, supplier: string | null, bandwidth?: string | null, port?: BearerType): string {
  if (!productName) return '';

  //Show all CityFibre products as "National"
  if (supplier === Supplier.CITYFIBRE) {
    if (isCityFibreFlex(supplier, bandwidth, port)) {
      return " National Flex";
    } else if (port === BearerType.LARGE || bandwidth === "10000") {
      return ` ${productName}`;
    } else {
      return " National";
    }
  }

  return (supplier === Supplier.OPENREACH) ? ` ${productName}` : '';
}